import { FeedbackTrigger } from '../types/Feedback';
import axiosInstance from './axiosCreator';

export const addUserFeedback = async (
  userId: string,
  trigger: FeedbackTrigger,
  rating?: number,
  comment?: string,
  skipped?: boolean
) => {
  try {
    const response = await axiosInstance.post(`/feedback`, {
      userId,
      trigger,
      rating,
      comment,
      skipped,
    });
    return response.data;
  } catch (error) {
    console.error('Error adding user feedback:', error);
    throw error;
  }
};
